// extracted by mini-css-extract-plugin
export default {"wrapper":"image_wrapper__fQfJ+","loader":"image_loader__xCF7Z"};